import React from "react";
import Badge from "../../../shared/ui/Badge";
import Input from "../../../shared/ui/Input";
import Button from "../../../shared/ui/Button";
import Card from "../../../shared/ui/Card";
import colors from "../../../shared/theme/colors";
import radius from "../../../shared/theme/radius";
import shadows from "../../../shared/theme/shadows";
import typography from "../../../shared/theme/typography";

export default function ProfileHealthIssuesField({
  isEditing,
  profile,
  healthQuery,
  setHealthQuery,
  isHealthOpen,
  setIsHealthOpen,
  healthInputRef,
  healthDropdownWrapperRef,
  healthOptions,
  canAddMoreHealthIssues,
  addHealthIssue,
  removeHealthIssue,
  handleHealthKeyDown,
}) {
  const issues = profile.healthIssues || [];

  return (
    <div ref={healthDropdownWrapperRef}>
      <p
        style={{
          fontFamily: typography.fontFamily,
          fontSize: typography.size.sm,
          fontWeight: typography.weight.medium,
          color: colors.textPrimary,
          marginBottom: 6,
        }}
      >
        Condições para acompanhamento de saúde (até 5 opcional)
      </p>

      {/* Chips */}
      {issues.length > 0 ? (
        <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
          {issues.map((item) => (
            <Badge key={item}>
              <span style={{ display: "flex", alignItems: "center", gap: 6 }}>
                {item}

                {isEditing && (
                  <button
                    type="button"
                    onClick={() => removeHealthIssue(item)}
                    style={{
                      background: "transparent",
                      border: "none",
                      cursor: "pointer",
                      fontSize: 12,
                      lineHeight: 1,
                      color: colors.primary,
                    }}
                  >
                    ×
                  </button>
                )}
              </span>
            </Badge>
          ))}
        </div>
      ) : (
        !isEditing && (
          <p
            style={{
              fontFamily: typography.fontFamily,
              fontSize: typography.size.sm,
              color: colors.textSecondary,
            }}
          >
            Não informado
          </p>
        )
      )}

      {/* Input + Dropdown */}
      {isEditing && (
        <div className="relative" style={{ marginTop: 12 }}>
          <Input
            ref={healthInputRef}
            placeholder={
              canAddMoreHealthIssues
                ? "Digite e pressione Enter"
                : "Limite de 5 atingido"
            }
            value={healthQuery}
            onChange={(event) => {
              setHealthQuery(event.target.value);
              setIsHealthOpen(true);
            }}
            onKeyDown={handleHealthKeyDown}
            onFocus={() => setIsHealthOpen(true)}
            disabled={!canAddMoreHealthIssues}
          />

          {isHealthOpen && canAddMoreHealthIssues && (
            <Card
              style={{
                position: "absolute",
                top: "calc(100% + 8px)",
                left: 0,
                right: 0,
                zIndex: 20,
                padding: 0,
                overflow: "hidden",
              }}
            >
              <ul
                style={{
                  maxHeight: 240,
                  overflow: "auto",
                  margin: 0,
                  padding: 0,
                  listStyle: "none",
                }}
              >
                {healthQuery.trim() && (
                  <li>
                    <button
                      type="button"
                      onPointerDown={(e) => e.preventDefault()}
                      onClick={() => addHealthIssue(healthQuery.trim())}
                      style={{
                        width: "100%",
                        textAlign: "left",
                        padding: "12px 14px",
                        background: "transparent",
                        border: "none",
                        fontFamily: typography.fontFamily,
                        fontSize: typography.size.sm,
                        fontWeight: typography.weight.bold,
                        color: colors.primary,
                        cursor: "pointer",
                      }}
                    >
                      Adicionar “{healthQuery.trim()}”
                    </button>
                  </li>
                )}

                {healthOptions.map((option) => (
                  <li key={option}>
                    <button
                      type="button"
                      onPointerDown={(e) => e.preventDefault()}
                      onClick={() => addHealthIssue(option)}
                      style={{
                        width: "100%",
                        textAlign: "left",
                        padding: "12px 14px",
                        background: "transparent",
                        border: "none",
                        fontFamily: typography.fontFamily,
                        fontSize: typography.size.sm,
                        color: colors.textPrimary,
                        cursor: "pointer",
                      }}
                    >
                      {option}
                    </button>
                  </li>
                ))}
              </ul>

              <div
                style={{
                  borderTop: `1px solid ${colors.border}`,
                  padding: "10px 14px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <span
                  style={{
                    fontFamily: typography.fontFamily,
                    fontSize: typography.size.xs,
                    color: colors.textSecondary,
                  }}
                >
                  {issues.length}/5 selecionados
                </span>

                <Button
                  variant="ghost"
                  size="sm"
                  onClick={() => setIsHealthOpen(false)}
                >
                  Fechar
                </Button>
              </div>
            </Card>
          )}
        </div>
      )}
    </div>
  );
}